import { render, staticRenderFns } from "./ProductChooserDialog.vue?vue&type=template&id=3334db2e&scoped=true"
import script from "./ProductChooserDialog.vue?vue&type=script&lang=ts"
export * from "./ProductChooserDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProductChooserDialog.vue?vue&type=style&index=0&id=3334db2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334db2e",
  null
  
)

export default component.exports